App.controller('GenerateReportCtrl', GenerateReportCtrl);

GenerateReportCtrl.$inject = [
    '$scope',
    'localStorageService',
    'DialogService',
    'reportFactory',
    'responseFactory',
    'DataDrivenDialogService'
];

function GenerateReportCtrl($scope, localStorageService, DialogService, reportFactory, responseFactory, DataDrivenDialogService) {
    var vm = this;

    vm.processing = false;
    vm.reportType = '';

    vm.generateReport = generateReport;
    vm.validate360 = validate360;
    vm.generate360SupervisorsPrePost = generate360SupervisorsPrePost;
    vm.generateSelf = generateSelf;
    vm.generateSelfPrePost = generateSelfPrePost;
    vm.generate360RespondentsPrePost = generate360RespondentsPrePost;
    vm.generate2019Self = generate2019Self;
    vm.generate2019SelfPrePost = generate2019SelfPrePost;
    vm.generate2019360Report = generate2019360Report;
	vm.validate2019360 = validate2019360;
	vm.generate2019360RespondentsPrePost = generate2019360RespondentsPrePost;
	vm.validate2019prepost360 = validate2019prepost360;

    function generateReport(code) {
        switch (vm.reportType) {
            case 'self':
                vm.generateSelf(code);

                vm.reportType = '';
                break;
            case 'self_pre_post':
                vm.generateSelfPrePost(code);

                vm.reportType = '';
                break;
            case 'three_sixty':
                vm.validate360(code);

                vm.reportType = '';
                break;
            case 'three_sixty_supervisors_pre_post':
                vm.generate360SupervisorsPrePost(code);

                vm.reportType = '';
                break;
            case 'three_sixty_respondents_pre_post':
                vm.generate360RespondentsPrePost(code);

                vm.reportType = '';
                break;
            case 'self_report_2019':
                vm.generate2019Self(code);

                vm.reportType = '';
                break;
            case 'self_report_2019_pre_post':
                vm.generate2019SelfPrePost(code);

                vm.reportType = '';
                break;
            case 'report_2019_360':
                vm.validate2019360(code);

                vm.reportType = '';
                break;
			case 'report_2019_360_resp_prepost':
				vm.validate2019prepost360(code);
				
				vm.reportType = '';
				break;
        }
    }

    function validate360(code) {
        vm.processing = true;

        DialogService.success('The 360 report is being prepared', 'Report Processing');

        reportFactory.validate360(code).then(function() {
            // if the report is valid, generate right away
            exclude360Responses(code);
        }).catch(function(response) {
            // otherwise confirm with user
            var message = '';

            if (Object.prototype.toString.call(response.message) === '[object Array]') {
                message = response.message.join(', ');
            } else {
                message = response.message;
            }

            DialogService.confirm('generate this report', message, function(result) {
                confirmGenerate360(result, code);
            });
        });

    }

    function confirmGenerate360(result, code) {
        if (result === true) {
            // if user approves, generate anyway
            exclude360Responses(code)
        } else {
            // otherwise exit and update buttons
            $scope.$apply(function() {
                vm.processing = false;
            });
        }

        return true;
    }

    function exclude360Responses(code) {
        DialogService.close();

        // let the user select the responses to exclude
        responseFactory.responses(code, 'pre').then(function(response) {
            DataDrivenDialogService.show('ExcludeResponses', response, function(excluded) {
                generate360(code, excluded);
            });
        });
    }

    function generate360(code, excluded) {
        vm.processing = true;

        DialogService.success(
            'The 360 report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generate360(code,excluded).then(initiateReportDownload).catch(cancelProcessing);
    }
	
    function validate2019360(code) {
        vm.processing = true;

        DialogService.success('The 360 report is being prepared', 'Report Processing');

        reportFactory.validate2019360(code).then(function() {
            // if the report is valid, generate right away
            exclude2019360Responses(code);
        }).catch(function(response) {
            // otherwise confirm with user
            var message = '';

            if (Object.prototype.toString.call(response.message) === '[object Array]') {
                message = response.message.join(', ');
            } else {
                message = response.message;
            }

            DialogService.confirm('generate this report', message, function(result) {
                confirmGenerate2019360(result, code);
            });
        });

    }

    function confirmGenerate2019360(result, code) {
        if (result === true) {
            // if user approves, generate anyway
            exclude2019360Responses(code)
        } else {
            // otherwise exit and update buttons
            $scope.$apply(function() {
                vm.processing = false;
            });
        }

        return true;
    }

    function exclude2019360Responses(code) {
        DialogService.close();

        // let the user select the responses to exclude
        responseFactory.responses(code, 'pre').then(function(response) {
            DataDrivenDialogService.show('ExcludeResponses', response, function(excluded) {
				console.log(excluded);
                generate2019360Report(code, excluded);
            });
        });
    }
	

    function generate360SupervisorsPrePost(code) {
        vm.processing = true;

        DialogService.success(
            'The 360 Supervisors Pre/Post report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generate360SupervisorsPrePost(code).then(initiateReportDownload).catch(cancelProcessing);
    }

    function generateSelf(code) {
        vm.processing = true;

        DialogService.success(
            'The Self report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generateSelf(code).then(initiateReportDownload).catch(cancelProcessing);
    }

    function generateSelfPrePost(code) {
        vm.processing = true;

        DialogService.success(
            'The Self Pre/Post report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generateSelfPrePost(code).then(initiateReportDownload).catch(cancelProcessing);
    }

    function generate360RespondentsPrePost(code) {
        vm.processing = true;

        DialogService.success(
            'The 360 Respondents Pre/Post report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generate360RespondentsPrePost(code).then(initiateReportDownload).catch(cancelProcessing);
    }

    function generate2019Self(code, excluded) {
        vm.processing = true;

        DialogService.success(
            'The 2019 Self report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generate2019Self(code,excluded).then(initiateReportDownload).catch(cancelProcessing);
    }

    function generate2019SelfPrePost(code, excluded) {
        vm.processing = true;

        DialogService.success(
            'The 2019 Self Pre/Post report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generate2019SelfPrePost(code,excluded).then(initiateReportDownload).catch(cancelProcessing);
    }

    function generate2019360Report(code, excluded) {
        vm.processing = true;

        DialogService.success(
            'The 2019 360 report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generate2019360Report(code,excluded).then(initiateReportDownload).catch(cancelProcessing);
    }
	
    function validate2019prepost360(code) {
        vm.processing = true;

        DialogService.success('The 360 report is being prepared', 'Report Processing');

        reportFactory.validate2019prepost360(code).then(function() {
            // if the report is valid, generate right away
            exclude2019prepost360Responses(code);
        }).catch(function(response) {
            // otherwise confirm with user
            var message = '';

            if (Object.prototype.toString.call(response.message) === '[object Array]') {
                message = response.message.join(', ');
            } else {
                message = response.message;
            }

            DialogService.confirm('generate this report', message, function(result) {
                confirmGenerate2019prepost360(result, code);
            });
        });

    }

    function confirmGenerate2019prepost360(result, code) {
        if (result === true) {
            // if user approves, generate anyway
            exclude2019prepost360Responses(code)
        } else {
            // otherwise exit and update buttons
            $scope.$apply(function() {
                vm.processing = false;
            });
        }

        return true;
    }

    function exclude2019prepost360Responses(code) {
        DialogService.close();

        // let the user select the responses to exclude
        responseFactory.responses(code, 'both').then(function(response) {
            DataDrivenDialogService.show('ExcludeResponses', response, function(excluded) {
				console.log(excluded);
                generate2019360RespondentsPrePost(code, excluded);
            });
        });
    }

    function generate2019360RespondentsPrePost(code, excluded) {
        vm.processing = true;

        DialogService.success(
            'The 360 Respondents Pre/Post report is being generated, and it will automatically be downloaded upon completion',
            'Report Processing'
        );

        reportFactory.generate2019360RespondentsPrePost(code,excluded).then(initiateReportDownload).catch(cancelProcessing);
    }

    function initiateReportDownload(response) {
        vm.processing = false;

        DialogService.close();

        location.href = web + 'reports/' + response.filename + '?token=' + localStorageService.get('token');
    }

    function cancelProcessing() {
        vm.processing = false;
    }
}
